"use strict";

module.exports = {
  'name': 'sinh',
  'category': 'Trigonometry',
  'syntax': ['sinh(x)'],
  'description': 'Compute the hyperbolic sine of x in radians.',
  'examples': ['sinh(0.5)'],
  'seealso': ['cosh', 'tanh']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/sinh.js
// module id = 975
// module chunks = 0